import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { DateTime, Interval } from "luxon";

import { useStyles } from "@/hooks/useStyles.ts";
import { CarePlan } from "@/models/CarePlanModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { toDateTime } from "@/utils/dateUtils.ts";

export type PeriodColumnProps = CellContext<CarePlan, unknown>;

export const PeriodColumn: React.FC<PeriodColumnProps> = ({ row: { original } }) => {
  const styles = useStyles(makeStyles);

  return (
    <Typography className={styles.container} variant="body">
      {Interval.fromDateTimes(toDateTime(original.periodStart), toDateTime(original.periodEnd)).toLocaleString(
        DateTime.DATE_SHORT,
      )}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({
    textWrap: "wrap",
  }),
});
